import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const LightingBoltIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 12 16" {...props}>
      <path
        d="M11.5482 7.1325C11.7373 6.86775 11.5481 6.5 11.2227 6.5H7.9C7.67909 6.5 7.5 6.32091 7.5 6.1V0.872279C7.5 0.288576 6.75103 0.0485572 6.41176 0.523536L0.451783 8.8675C0.262678 9.13225 0.451927 9.5 0.777276 9.5H4.1C4.32091 9.5 4.5 9.67909 4.5 9.9V15.1277C4.5 15.7114 5.24897 15.9514 5.58824 15.4765L11.5482 7.1325Z"
        fill={props.fill ?? '#3F1D75'}
      />
    </SvgWrapper>
  );
};
